import ChannelAvatar from '@sendbird/uikit-react/ui/ChannelAvatar';
import EditDetailsModal from '@sendbird/uikit-react/ChannelSettings/components/EditDetailsModal';
import { useMemo, useState } from 'react';
import { useTranslate } from 'ra-core';
import { useChannelSettingsContext } from '@sendbird/uikit-react/ChannelSettings/context';
import { getChatChannelName } from '../../../utils/getChatChannelName';
import { Role } from '@sendbird/chat';
import { useCurrentUser } from '../../../auth/currentUserContext';
import { Button } from '../../../components/ui/button';
import { useResolvedThemeMode } from '../../../layout/useResolvedThemeMode';

export const CustomChannelProfile = () => {
  const translate = useTranslate();
  const { channel } = useChannelSettingsContext();
  const currentUser = useCurrentUser();
  const themeMode = useResolvedThemeMode();
  const [showModal, setShowModal] = useState(false);
  const chatName = useMemo(
    () => getChatChannelName(channel, currentUser),
    [channel, currentUser]
  );

  const handleEditClick = () => {
    setShowModal(true);
  };

  const isUserChannelOperator = channel.myRole === Role.OPERATOR;

  return (
    <>
      <div className="flex flex-col">
        {/* Only operators are allowed to edit channel profile */}
        {isUserChannelOperator && (
          <Button
            type="button"
            variant="ghost"
            onClick={handleEditClick}
            className="mt-1 ml-auto mr-1"
          >
            {translate('chat.edit')}
          </Button>
        )}
        <div className={`self-center ${!isUserChannelOperator ? 'pt-1' : ''}`}>
          <ChannelAvatar
            channel={channel}
            userId={currentUser.id.toString()}
            theme={themeMode}
            width={80}
            height={80}
          />
        </div>
        <p className="truncate px-2 pb-1 text-center text-sm">{chatName}</p>
      </div>

      {showModal && (
        <EditDetailsModal
          onCancel={() => setShowModal(false)}
          onSubmit={() => setShowModal(false)}
        />
      )}
    </>
  );
};
